import { render, staticRenderFns } from "./AngebotSucheModal.vue?vue&type=template&id=52116cbd"
import script from "./AngebotSucheModal.vue?vue&type=script&lang=js"
export * from "./AngebotSucheModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports